export class SDKResponse {
    code: string;
    data: ResponseData;
    message: string;
    success: boolean;

    constructor(apiResult: any | null) {
        if (apiResult) {
            this.data = new ResponseData(apiResult);
            this.success = true;
            this.setStatusCode(apiResult.status);
            this.setStatusMessage(apiResult.status);
        } else {
            this.data = null;
            this.success = false;
            this.setStatusCode('');
            this.setStatusMessage('');
        }
    }

    public setStatusCode(status: string) {
        if (!status) this.message = 'Ocorreu um erro durante o processo.';

        if (status == 'AGA') {
            this.message = 'Pedido em pré-análise, aguardando biometria/prova de vida.';
        } else if (status == 'PEN') {
            this.message = 'Proposta com pendência.';
        } else if (status == 'NEG') {
            this.message = 'Proposta negada.';
        } else if (status == 'APR') {
            this.message = 'Proposta aprovada.';
        } else if (status == 'BOR') {
            this.message = 'Proposta com borderô gerado.';
        } else if (status == 'FOR') {
            this.message = 'Proposta formalizada.';
        } else if (status == 'CAN') {
            this.message = 'Proposta cancelada.';
        } else if (status == 'DEV') {
            this.message = 'Proposta devolvida.';
        } else if (status == 'ERR') {
            this.message = 'Erro ocorrido ao executar o processo.';
        } else {
            this.message = 'Status de proposta desconhecido.';
        }
    }

    private setStatusMessage(status: string) {
        if (!status) this.code = 'erro_durante_processo';

        if (status == 'AGA') {
            this.code = 'proposta_em_pre_analise';
        } else if (status == 'PEN') {
            this.code = 'proposta_com_pendencia';
        } else if (status == 'NEG') {
            this.code = 'proposta_negada';
        } else if (status == 'APR') {
            this.code = 'proposta_aprovada';
        } else if (status == 'BOR') {
            this.code = 'proposta_com_bordero_gerado';
        } else if (status == 'FOR') {
            this.code = 'proposta_formalizada';
        } else if (status == 'CAN') {
            this.code = 'proposta_cancelada';
        } else if (status == 'DEV') {
            this.code = 'proposta_devolvida';
        } else if (status == 'ERR') {
            this.code = 'erro_durante_processo';
        } else {
            this.code = 'status_desconhecido';
        }
    }
}

class ResponseData {
    totalFinanciamento: number;
    totalJuros: number;
    taxaMensal: number;
    numParcelas: number;
    valorParcelas: number;
    dataPrimeiroVencimento: number;

    constructor(apiResult: any) {
        this.totalFinanciamento = (apiResult.vrFinanciado) ? apiResult.vrFinanciado : null;
        this.totalJuros = (apiResult.jurosTotal) ? apiResult.jurosTotal : null;
        this.taxaMensal = (apiResult.cet) ? apiResult.cet : null;
        this.numParcelas = (apiResult.plano) ? apiResult.plano : null;
        this.valorParcelas = (apiResult.vrParcela) ? apiResult.vrParcela : null;
        this.dataPrimeiroVencimento = (apiResult.dtPrimeiroVencimento) ? apiResult.dtPrimeiroVencimento : null;
    }
}